import store from './../../store'
import Unit from '@models/building/Unit'
import Room from '@models/building/Room'

import Project from '@models/project/Project'
import Configuration from '@models/project/Configuration'
import Contact from '@models/project/Contact'
import StoredArticle from '@models/articles/StoredArticle'
import StoredRoomArticle from '@models/articles/StoredRoomArticle'

export default {
  validatePossiblePages() {
    const keys = Object.keys(store.state.navigation.value.sides)
    for (let i = keys.length - 1; i >= 0; i--) {
      if (keys[store.state.navigation.value.index] == 'Overview' && store.state.navigation.value.sides.Overview.skipped == true && (keys[i] == 'Devices' || keys[i] == 'Equipments')) {
        this.disablePage(keys[i])
      } else if (store.state.navigation.value.index < i) {
        this.disablePage(keys[i])
      } else if (store.state.navigation.value.index > i) {
        this.activatePage(keys[i])
      } else {
        this['validate' + keys[i] + 'Page']()
      }
    }
    this.setNextClasses(keys)
    this.setPreviousClasses()
  },
  validateBuildingPage() {
    var valid = true
    /**
     * Validate Project Part
     */
    this.configuration = Configuration.query().where('selectedConfiguration', true).first()
    if (this.configuration == null || this.configuration == undefined) {
      valid = false
    } else if (this.configuration.description == null || this.configuration.description == '') {
      valid = false
    }

    /**
     * Validate Building Part
     */
    this.units = Unit.all()
    this.units.forEach(
      function (unit) {
        if (unit.name == null || unit.name == '') valid = false
        if (unit.volume == null || unit.volume <= 0) valid = false
        if (unit.space == null || unit.space <= 0) valid = false
        if (unit.height == null || unit.height <= 0) valid = false
        if (unit.infiltration == null || unit.infiltration == 0) valid = false
        if (unit.moisureProtection == null || unit.moisureProtection == 0) valid = false
        if (unit.ventilationMeasure == null || unit.ventilationMeasure <= 0) valid = false
      }.bind(this)
    )

    if (valid === true) this.activatePage('Rooms')
  },
  validateRoomsPage() {
    if (Room.query().count() > 0) this.activatePage('AirVolumes')
  },
  validateAirVolumesPage() {
    var valid = true
    if (valid == true) this.activatePage('Devices')
  },
  validateDevicesPage() {
    let valid = true
    // get all units with articles
    const units = Unit.query().with(['rooms']).get()
    // loop through all units
    units.forEach((unit) => {
      // check if unit has no rooms if return
      if (unit.rooms.length == 0) return
      // if unit ventilation measure is 3 or 4 check if StoredArticle with accessorygroup 1 and quantity > 0 exists
      if (unit.ventilationMeasure == 3 || unit.ventilationMeasure == 4) {
        if (
          !StoredArticle.query()
            .where('unit_id', unit.id)
            .where('accessorygroup_id', 1)
            .where('quantity', (quantity) => quantity >= 1)
            .exists()
        ) {
          valid = false
        }
      } else {
        unit.rooms.forEach((room) => {
          // If room has no ventilationMeasure or ventilationMeasure 7 return
          if (room.ventilationMeasure == null || room.ventilationMeasure == 7) return
          // Check if StoredRoomArticle with accessorygroup 1 and quantity > 0 exists
          if (
            !StoredRoomArticle.query()
              .where('room_id', room.id)
              .where('accessorygroup_id', 1)
              .where('quantity', (quantity) => quantity >= 1)
              .exists()
          ) {
            valid = false
          }
        })
      }
    })
    if (valid == true) this.activatePage('Equipments')
  },
  validateEquipmentsPage() {
    let valid = true
    // get all units with rooms
    const units = Unit.query().with(['rooms.airvolume']).get()
    // loop through all units
    units.forEach((unit) => {
      // if unit ventilation measure is not 3 or 4 return
      if (unit.ventilationMeasure != 3 && unit.ventilationMeasure != 4) return
      // if unit has no rooms return
      if (unit.rooms.length == 0) return
      // loop through all rooms
      unit.rooms.forEach((room) => {

        // check if StoredRoomArticle has article with quantity > 0
        // If room has no ventilationMeasure or ventilationMeasure 7 return
        if (room.ventilationMeasure == null || room.ventilationMeasure === 7) return

        if (
          !StoredRoomArticle.query()
            .where('room_id', room.id)
            .where('quantity', (quantity) => quantity >= 1)
            .exists()
        ) {
         
          valid = false

        }
      })
    })

    if (valid == true) this.activatePage('Overview')
  },
  validateOverviewPage() {
  },
  activatePage(key) {
    this.units = Unit.all()
    var index = store.state.navigation.value.sides[key].classes.indexOf('disabled')
    if (index > -1) {
      store.state.navigation.value.sides[key].classes.splice(index, 1)
    }
  },
  disablePage(key) {
    var index = store.state.navigation.value.sides[key].classes.indexOf('disabled')
    if (index == -1) store.state.navigation.value.sides[key].classes.push('disabled')
  },
  setNextClasses(keys) {
    if (
      store.state.navigation.value.index < keys.length - 1 &&
      (store.state.navigation.value.sides[keys[store.state.navigation.value.index + 1]].classes.includes('disabled') == false || (store.state.navigation.value.index == 3 && store.state.navigation.value.sides[keys[store.state.navigation.value.index + 2]].classes.includes('disabled') == false))
    ) {
      var index = store.state.navigation.value.nextClasses.indexOf('disabled')
      if (index > -1) store.state.navigation.value.nextClasses.splice(index, 1)
    } else {
      var index = store.state.navigation.value.nextClasses.indexOf('disabled')
      if (index == -1) store.state.navigation.value.nextClasses.push('disabled')
    }
  },
  setPreviousClasses() {
    if (store.state.navigation.value.index > 0) {
      var index = store.state.navigation.value.previousClasses.indexOf('disabled')
      if (index > -1) store.state.navigation.value.previousClasses.splice(index, 1)
    } else {
      var index = store.state.navigation.value.previousClasses.indexOf('disabled')
      if (index == -1) store.state.navigation.value.previousClasses.push('disabled')
    }
  },
}
